import React from 'react'

export const MChatGif = ({ gifs }) => <img src={gifs[0]} alt="Gif" />
